export default __webpack_public_path__ + "static/media/sanmar22.480af8aa.jpg";